import { resolveMediaUrl } from "./resolveMediaUrl";

export const downloadByUrl = async (url: string, name: string) => {
  const response = await fetch(resolveMediaUrl(url));

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

export const urlToFile = async (url: string, fileName: string, mimeType: string): Promise<File> => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], fileName, { type: mimeType });
};